import { render, staticRenderFns } from "./SellerOfferApprovedRegistrationDetails.vue?vue&type=template&id=56e174af&scoped=true"
import script from "./SellerOfferApprovedRegistrationDetails.vue?vue&type=script&lang=js"
export * from "./SellerOfferApprovedRegistrationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e174af",
  null
  
)

export default component.exports